import React, {Component} from 'react';
import {Button, ControlLabel, Form, FormControl, FormGroup} from 'react-bootstrap';
import {createForm} from "../../util/form";
import {inject, observer} from 'mobx-react';

@inject('EventStore', 'MemberStore')



@observer
export class MemberUpdateForm extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            validate: false,
            validateList: {}
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        const formData = event.target;
        const body = {
            mcode: formData['mcode'].value,
            email: formData['email'].value,
            mobile: formData['mobile'].value,
            address: formData['address'].value,
            districtid: formData['districtid'].value,
            amphurid: formData['amphurid'].value,
            provinceid: formData['provinceid'].value,
            zip: formData['zip'].value,
        };
        this.props.EventStore.register(body);
        return;
    }

    handleChange(e) {
        const control = e.target;
        this.props.MemberStore.updateMember(control.name, control.value);
    }

    render() {
        const store = this.props.MemberStore;
        return (
            <div className="member-register-form" style={{
                height: '80vh',
                overflow: 'auto'
            }}>
                <Form onSubmit={this.handleSubmit}>
                    <div className="form-header">
                        <h4>กรุณากรอกข้อมูล</h4>
                    </div>
                    <div className="form-body">
                        <FormGroup>
                            <ControlLabel>รหัสสมาชิก</ControlLabel>
                            <FormControl type="text"
                                         name="mcode"
                                         disabled
                                         onChange={this.handleChange}
                                         value={store.member.mcode}/>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>ชื่อ นามสกุล</ControlLabel>
                            <FormControl type="text"
                                         disabled
                                         onChange={this.handleChange}
                                         value={store.member.name_t}/>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>E-mail</ControlLabel>
                            <FormControl type="email"
                                         name="email"
                                         onChange={this.handleChange}
                                         value={store.member.email}/>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>เบอร์โทรศัพท์</ControlLabel>
                            <FormControl type="text"
                                         name="mobile"
                                         onChange={this.handleChange}
                                         value={store.member.mobile}/>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>ที่อยู่</ControlLabel>
                            <FormControl type="text"
                                         name="address"
                                         onChange={this.handleChange}
                                         value={store.member.address}/>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>แขวง/ตำบล</ControlLabel>
                            <FormControl type="text"
                                         name="districtid"
                                         onChange={this.handleChange}
                                         value={store.member.districtid}/>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>อำเภอ/เขต</ControlLabel>
                            <FormControl type="text"
                                         name="amphurid"
                                         onChange={this.handleChange}
                                         value={store.member.amphurid}/>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>จังหวัด</ControlLabel>
                            <FormControl type="text"
                                         name="provinceid"
                                         onChange={this.handleChange}
                                         value={store.member.provinceid}/>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>รหัสไปรษณีย์</ControlLabel>
                            <FormControl type="text"
                                         name="zip"
                                         onChange={this.handleChange}
                                         value={store.member.zip}/>
                        </FormGroup>
                    </div>
                    <div className="form-footer">
                        <Button
                            type='submit'
                            bsStyle='primary' fill
                        >
                            ยืนยัน
                        </Button>
                        <Button
                            bsStyle="info" fill style={{marginLeft: 16}}
                            onClick={() => {this.props.EventStore.reInit()}}
                        >
                            ยกเลิก
                        </Button>
                    </div>
                </Form>
            </div>

        )
    }


}

export default MemberUpdateForm;


// WEBPACK FOOTER //
// ./src/component/member/MemberUpdateForm.jsx